import { atom } from "recoil";

export const allPermissions = atom({
  key: "allPermissions",
  default: [],
});